import React from "react";
import { useTranslation } from "react-i18next";

import CheckMarkSuccessful from "../../../images/checkmark_successful.svg";
import DefaultOnboardingStatusPage from "../../ReusablePages/DefaultOnboardingStatusPage/DefaultOnboardingStatusPage";
import { OnboardingSteps, ROUTES } from "../../../utils/constants";
import GameControllerIcon2 from "../../../components/icons/GameControllerIcon2";

const redirectPath = ROUTES.ROOT.SIGN_UP;

function SignUpSuccessfulPage() {
  const { t } = useTranslation("common");
  return (
    <DefaultOnboardingStatusPage
      titleText={t("onboarding.sign_up_successful")}
      secondaryText={
        t("onboarding.you_have_successfully_signed_up_to_sigma_games") +
        t("punctuations.exclammation")
      }
      primaryImage={CheckMarkSuccessful}
      secondaryIcon={<GameControllerIcon2 />}
      redirectDelay={3000}
      redirectPath={redirectPath}
      nextStep={OnboardingSteps.CLAIM_USERNAME}
    />
  );
}

export default SignUpSuccessfulPage;
